import scroller from './scroller';

const $home = document.querySelector('.home');
const $video = document.querySelector('.home__video');
const $title = document.querySelectorAll('.home__title');
const $text = document.querySelector('.home__text');

const showText = () => {
	$text.querySelectorAll('p').forEach(($pCurrent) => {
		gsap.from($pCurrent, {
			scrollTrigger: {
				trigger: $pCurrent,
				start: 'top+=75 bottom',
				once: true,
				// markers: {
				// 	startColor: 'red',
				// 	endColor: 'red',
				// },
				scroller: scroller.getElement(),
			},
			duration: 0.35,
			clearProps: 'all',
			transition: 'none',
			y: 50,
			autoAlpha: 0,
		});
	});
};

const showElements = () => {
	$video.classList.remove('is-hide');

	$title.forEach(($titleCurrent) => {
		$titleCurrent.classList.remove('is-hide');
	});

	gsap
		.timeline()
		.from($video, {
			duration: 0.4,
			clearProps: 'opacity',
			opacity: 0,
		})
		.from($home.querySelectorAll('.frame'), {
			duration: 0.8,
			clearProps: true,
			opacity: 0,
			y: 120,
			rotate: -5,
		}, '-=0.2');
};

const init = () => {
	if ($home === null) {
		return;
	}

	showElements();
	showText();
};

export default {
	init,
};
